import type { Address } from "~/types/addressTypes.ts";
import { nl2br } from "~/utils/stringUtils.tsx";

type Props = {
	address: Address;
	name?: string;
};

const AddressDisplay = ({ address, name }: Props) => {
	const { addressLine1, addressLine2, addressLine3, postCode, city, country } = address;

	return (
		<div>
			{name && <><span>{nl2br(name)}</span><br /></>}
			{addressLine1 && <><span>{addressLine1}</span><br /></>}
			{addressLine2 && <><span>{addressLine2}</span><br /></>}
			{addressLine3 && <><span>{addressLine3}</span><br /></>}
			{(postCode || city) && <><span>{postCode} {city}</span><br /></>}
			{country && <span>{country.displayName}</span>}
		</div>
	);
};

export default AddressDisplay;
